export default "__VITE_ASSET__xEN5pD5V__"